<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    @close="closeDialog"
  >
    <div class="form">
      <el-form
        ref="form"
        :model="form"
        :rules="form_rules"
        :label-width="dialog.formLabelWidth"
        style="margin: 10px; width: auto"
      >
        <el-form-item prop="coursePerformance" label="课堂表现">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入课堂表现"
            v-model="form.coursePerformance"
          ></el-input>
        </el-form-item>

        <el-form-item prop="recordNote" label="学习内容">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入学习内容"
            v-model="form.recordNote"
          ></el-input>
        </el-form-item>

        <el-form-item class="text_right">
          <el-button @click="isVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit('form')">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { updateRecord } from "@/api/record";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";

export default {
  name: "addFundDialogs",
  data() {
    let validateData = (rule, value, callback) => {
      if (value === "") {
        let text;
        if (rule.field == "telephoneNumber") {
          text = "手机号";
        } else if (rule.field == "name") {
          text = "姓名";
        }
        callback(new Error(text + "不能为空~"));
      } else {
        let numReg = /^1[3456789]\d{9}$/;
        if (!numReg.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      }
    };
    return {
      isVisible: this.isShow,
      title: "修改课堂记录",
      form: {
        id: "",
        coursePerformance: "",
        recordNote: "",
      },
      form_rules: {
        telephoneNumber: [
          { required: true, validator: validateData, trigger: "blur" },
        ],
        name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        memberType: [
          { required: true, message: "请选择会员类型", trigger: "blur" },
        ],
        memberStatus: [
          { required: true, message: "请选择会员状态", trigger: "blur" },
        ],
      },
      //详情弹框信息
      dialog: {
        width: "400px",
        formLabelWidth: "120px",
      },
    };
  },
  props: {
    isShow: Boolean,
    dialogRow: Object,
    courseTypeList: Object,
    courseLocationList: Object,
    courseDetails: Object,
    stdName: String,
  },
  computed: {
    // ...mapGetters(["addCourseDialog"])
  },
  created() {},
  mounted() {
    this.form = this.dialogRow;
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    //表单提交
    onSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          //表单数据验证完成之后，提交数据;
          let formData = this[form];
          const para = Object.assign({}, formData);
          console.log(para);
          // edit
          updateRecord(para).then((res) => {
            console.log(res);
            if (res.data.code == 200) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              const para = {
                userName: getToken("USERNAME"),
                content:
                  "修改完课课程中学员(" +
                  this.stdName +
                  ")操作,课程日期为:" +
                  this.courseDetails.courseDate +
                  ",课程时间段:" +
                  this.courseDetails.courseTime +
                  ",课程地点:" +
                  this.courseDetails.courseLocation +
                  ",班级类型:" +
                  this.courseDetails.courseType,
              };
              console.log(para);
              addOperationRecord(para).then((res) => {
                console.log(res);
              });
              this.isVisible = false;
              this.$emit("getCourseList");
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
</style>
